export const getTechnicalReports = (state) => state.technicalReports;
export const getTechnicalReportDetails = (state) => state.technicalReportDetails;
